import React from 'react'
import './goods-list.less'
import GoodsItem from './goods-item/goods-item'
import { connect } from 'react-redux'
import { List, PullToRefresh, Toast } from 'antd-mobile'
import { fetchShopingCar } from '@/api/shopping-car'
import { setHeader } from '@/util/set-header'
import ReactDOM from 'react-dom'
const Item = List.Item
const APullToRefresh: any = PullToRefresh
interface Props {
  depot_id: string
}

const mapStateToProps = (state: any) => {
  return {
    depot_id: state.depot.id,
  }
}
@(connect(mapStateToProps) as any)
class GoodsList extends React.Component<any, any> {
  ptr!: PullToRefresh
  constructor(props: any) {
    super(props)
    this.state = {
      refreshing: false,
      list: [],
      height: document.documentElement.clientHeight - 45,
    }
  }

  UNSAFE_componentWillMount() {
    setHeader({ title: '商品列表' })
    this.getGoods = this.getGoods.bind(this)
    this.onRefresh = this.onRefresh.bind(this)
  }

  componentDidMount() {
    const { depot_id } = this.props
    if (depot_id) {
      this.getGoods(depot_id)
    }
    const height =
      document.documentElement.clientHeight -
      (ReactDOM.findDOMNode(this.ptr) as any).offsetTop
    this.setState({
      height,
    })
  }
  componentWillReceiveProps(nextProps: Props) {
    const nextDepotId = nextProps.depot_id
    const { depot_id } = this.props
    if (depot_id !== nextDepotId) {
      this.getGoods(nextDepotId)
    }
  }
  //获取列表数据
  async getGoods(depot_id: any) {
    Toast.loading('加载中', 0)
    let { data } = await fetchShopingCar(depot_id)

    Toast.hide()
    if (data.code === 'SUCCESS') {
      let list: any = []
      data.data.list.forEach((item: any) => {
        if (item.num !== '0') {
          list.push(item)
        }
      })
      this.setState({
        list: list,
      })
    } else {
      Toast.info(data.msg, 1)
    }
  }
    async onRefresh() {
    this.setState({ refreshing: true })
    let { depot_id } = this.props
    await this.getGoods(depot_id)
    this.setState({ refreshing: false })
  }

  render() {
    const numbers = this.state.list
    const listItems = numbers.map((item: any) => (
      <Item key={item.goods_id}>
        <GoodsItem goods={item} />
      </Item>
    ))
    return (
      <div className="fill-googs-list">
        <APullToRefresh
          refreshing={this.state.refreshing}
          onRefresh={this.onRefresh}
          ref={(el: any) => (this.ptr = el)}
          style={{
            height: this.state.height,
            overflow: 'auto',
          }}
        >
          <div className="fill-googs-list">
            <List>{listItems}</List>
          </div>
        </APullToRefresh>
      </div>
    )
  }
}

export default GoodsList
